// Generated by purs version 0.15.15
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Unscramble from "../Unscramble/index.js";
var toUnfoldable = /* #__PURE__ */ Data_Set.toUnfoldable(Data_Unfoldable.unfoldableArray);
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var map = /* #__PURE__ */ Data_Functor.map(/* #__PURE__ */ Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity));
var wrap = /* #__PURE__ */ Data_Newtype.wrap();
var fromFoldable = /* #__PURE__ */ Data_Set.fromFoldable(Data_Foldable.foldableArray);
var $$Set = function (x) {
    return x;
};
var udecodeSet = function (dictOrd) {
    return function (dictDecode) {
        return Unscramble.decodeSet(dictDecode)(dictOrd);
    };
};
var showSet = function (dictShow) {
    return Data_Set.showSet(dictShow);
};
var semigroupSet = function (dictOrd) {
    return Data_Set.semigroupSet(dictOrd);
};
var ordSet = function (dictOrd) {
    return Data_Set.ordSet(dictOrd);
};
var newtypeSet = {
    Coercible0: function () {
        return undefined;
    }
};
var monoidSet = function (dictOrd) {
    return Data_Set.monoidSet(dictOrd);
};
var foldableSet = Data_Set.foldableSet;
var eqSet = function (dictEq) {
    return Data_Set.eqSet(dictEq);
};
var encodeSet = function (dictEncode) {
    return {
        encode: (function () {
            var $29 = Foreign_Generic_Class.encode(Foreign_Generic_Class.arrayEncode(dictEncode));
            return function ($30) {
                return $29(toUnfoldable(unwrap($30)));
            };
        })()
    };
};
var decodeSet = function (dictOrd) {
    var fromFoldable1 = fromFoldable(dictOrd);
    return function (dictDecode) {
        return {
            decode: (function () {
                var $31 = map(function ($34) {
                    return wrap(fromFoldable1($34));
                });
                var $32 = Foreign_Generic_Class.decode(Foreign_Generic_Class.arrayDecode(dictDecode));
                return function ($33) {
                    return $31($32($33));
                };
            })()
        };
    };
};
export {
    $$Set as Set,
    newtypeSet,
    eqSet,
    ordSet,
    showSet,
    semigroupSet,
    monoidSet,
    udecodeSet,
    foldableSet,
    encodeSet,
    decodeSet
};
